import graphql from "babel-plugin-relay/macro";

export const HomeContentBaseQuery = graphql`
  query HomeContentBaseQuery {
    currentTenant {
      ...HomeContent_currentTenant
    }
  }
`;
